import script from "./SurveyConfiguratorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyConfiguratorView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__